export { default as routes } from './routes'

export { AGENT_DETAIL_PAGE, TEAM_DETAIL_PAGE } from './pages'
export {
  selectIsOnAgentOverviewPage,
  selectIsOnTeamOverviewPage,
  selectAgentOverviewName,
  selectTeamOverviewName,
} from './selectors'
